import api from './api'
import moment from 'moment'

export const getEventObject = (apiObject) => {
    
    const startWaypoint = {
        date: apiObject.start
    }
    const endWaypoint = {
        date: apiObject.end
    }
    
    const eventObject = {
        id: 0,
        date: apiObject.start,
        modified_gmt: moment().utc().format('YYYY-MM-DDTHH:mm:ss'),
        totalHours: moment(apiObject.end).diff(apiObject.start,'hours',true).toString(),
        waypoints: [startWaypoint,endWaypoint],
        assigneeIds: []
    }

    if( apiObject.distance ){
        eventObject.distance = apiObject.distance
    }

    if( apiObject.engineRunStart ){
        eventObject.engineRunStart = apiObject.engineRunStart
    }

    if( apiObject.engineRunEnd ){
        eventObject.engineRunEnd = apiObject.engineRunEnd
    }

    return eventObject;
}

const isEventInARange = (event,ranges) => {

    const eventStart = event.waypoints[0].date
    const eventEnd = event.waypoints[event.waypoints.length-1].date
    return isApiEventInRanges({start: eventStart, end: eventEnd},ranges)
}

const isApiEventInRanges = (event,ranges) => {
    
    if( ranges.length === 0 )
        return false;

    const eventStart = moment(event.start)
    const eventEnd = moment(event.end)

    if( !(eventStart.isAfter( ranges[0].start ) && eventEnd.isBefore(ranges[ranges.length-1].end)) ){
        return false;
    }
        
    if( ranges.length === 1)
        return true;

    const midIndex = Math.floor( ranges.length / 2 )
    const midRange = ranges[midIndex-1]

    if( eventEnd.isBefore(midRange.end) )
        return isApiEventInRanges(event,ranges.slice(0,midIndex));

    return isApiEventInRanges(event,ranges.slice(midIndex));
}

export const getNewEvents = async (ranges) => {

    //No tracker id, no new events;
    if(!api.trackerId) return [];

    const queryUrl = `${api.gps_api_url}/units/${api.trackerId}/events?accEvents=no&distance=no&apiKey=${api.gps_api_key}`
   
    const response = await fetch(queryUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        mode: 'cors',
        redirect: 'follow',
        body: JSON.stringify({'ranges': ranges})  
    })
   
    const apiObjects = await response.json()
 
    const eventObjects = apiObjects.reduce((eventsArray, apiObject) => [...eventsArray,...apiObject.events],[])
    return(eventObjects.map(getEventObject).filter( e => parseFloat(e.totalHours) > 0 ));
    
}

export const eventsInRanges = (events,ranges) => {
    return events.filter( e => isEventInARange(e,ranges) )
}

export const getCurrentPosition = async () => {
    const queryUrl = `${api.gps_api_url}/units/${api.trackerId}?apiKey=${api.gps_api_key}`

    const response = await fetch(queryUrl, {
        method: 'GET',
        mode: 'cors',
        redirect: 'follow' 
    })

    return await response.json();
}

export const getFirstEvent = async () => {
    const queryUrl = `${api.gps_api_url}/units/${api.trackerId}/first?apiKey=${api.gps_api_key}`

    const response = await fetch(queryUrl, {
        method: 'GET',
        mode: 'cors',
        redirect: 'follow' 
    })

    return await response.json();
}

export const getWaypoints = async (start,end) => {
    const queryUrl = `${api.gps_api_url}/units/${api.trackerId}/waypoints?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}&apiKey=${api.gps_api_key}`
    
    const response = await fetch(queryUrl, {
        method: 'GET',
        mode: 'cors',
        redirect: 'follow' 
    })

    return await response.json();
}

export const getWaypointsInRanges = async (ranges) => {
    //No tracker id, no new events;
    if(!api.trackerId) return [];

    const queryUrl = `${api.gps_api_url}/units/${api.trackerId}/waypoints?apiKey=${api.gps_api_key}`
    const fetchRange = {
        start: ranges[0].start,
        end: ranges[ranges.length-1].end
    }

    const response = await fetch(queryUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        mode: 'cors',
        redirect: 'follow',
        //body: JSON.stringify({'ranges': ranges})  
        body: JSON.stringify({'ranges': [fetchRange]})  
    })
   
    const apiObjects = await response.json()
    const eventObjects = apiObjects.reduce((eventsArray, apiObject) => [...eventsArray,...apiObject],[])
    return(eventObjects.filter(e => isApiEventInRanges({start: e.utc, end: e.utc},ranges)));
}